var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            [
              _vm.detailForm.planStatus !== "CANCEL" &&
              _vm.detailForm.planStatus !== "COMPLETED" &&
              !_vm.isRoles
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_SAVE,
                          expression: "QSPI_QBR_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSave("Save")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              (_vm.detailForm.planStatus == "IN_PLAN" ||
                _vm.detailForm.planStatus == "DELAYED") &&
              _vm.detailForm.qbrStatus == "DRAFT" &&
              !_vm.isRoles
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_GEN,
                          expression: "QSPI_QBR_GEN",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSave("Start")
                        },
                      },
                    },
                    [_vm._v("发起QBR")]
                  )
                : _vm._e(),
              (_vm.detailForm.planStatus == "IN_PLAN" ||
                _vm.detailForm.planStatus == "DELAYED") &&
              _vm.detailForm.qbrStatus !== "CLOSED" &&
              !_vm.isRoles
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_CANCEL,
                          expression: "QSPI_QBR_CANCEL",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSave("Cancle")
                        },
                      },
                    },
                    [_vm._v("Cancel QBR")]
                  )
                : _vm._e(),
              _vm.detailForm.planStatus == "CANCEL" && !_vm.isRoles
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_RECOVER,
                          expression: "QSPI_QBR_RECOVER",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSave("Recovery")
                        },
                      },
                    },
                    [_vm._v("恢复QBR")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onView },
                },
                [_vm._v("查看供应商历史表现")]
              ),
              ((_vm.detailForm.planStatus == "IN_PLAN" ||
                _vm.detailForm.planStatus == "DELAYED") &&
                _vm.detailForm.qbrStatus == "PENDING_BY_SUPPLIER" &&
                _vm.isRoles) ||
              ((_vm.detailForm.qbrStatus == "PENDING_BY_CQS" ||
                _vm.detailForm.qbrStatus == "SUBMITTED_BY_SUPPLIER") &&
                !_vm.isExsit)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_ADD_DOC,
                          expression: "QSPI_QBR_ADD_DOC",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSave("Material")
                        },
                      },
                    },
                    [_vm._v("提交材料")]
                  )
                : _vm._e(),
              ((_vm.detailForm.planStatus == "IN_PLAN" ||
                _vm.detailForm.planStatus == "DELAYED") &&
                _vm.detailForm.qbrStatus == "PENDING_ATTACHMENT_BY_SUPPLIER" &&
                _vm.isRoles) ||
              ((_vm.detailForm.qbrStatus == "PENDING_BY_CQS" ||
                _vm.detailForm.qbrStatus == "SUBMITTED_BY_SUPPLIER") &&
                _vm.isExsit)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_ADD_SUPP_DOC,
                          expression: "QSPI_QBR_ADD_SUPP_DOC",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onSave("Supplementary")
                        },
                      },
                    },
                    [_vm._v("提交补充材料")]
                  )
                : _vm._e(),
              _vm.detailForm.qbrStatus == "PENDING_BY_CQS" ||
              (_vm.detailForm.qbrStatus == "SUBMITTED_BY_SUPPLIER" &&
                !_vm.isRoles)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.QSPI_QBR_CLOSE,
                          expression: "QSPI_QBR_CLOSE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        disabled: _vm.detailForm.isDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onClose("Closed")
                        },
                      },
                    },
                    [_vm._v("关闭QBR")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "within_box" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "form_box" },
              [
                _c(
                  "el-form",
                  {
                    ref: "detailForm",
                    attrs: {
                      model: _vm.detailForm,
                      rules: _vm.rules,
                      "label-width": "110px",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "供应商集团名称",
                                  prop: "groupName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.groupName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "groupName", $$v)
                                    },
                                    expression: "detailForm.groupName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category2",
                                  prop: "category2Name",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.category2Name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "category2Name",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.category2Name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "计划月", prop: "month" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "value-format": "yyyy-MM",
                                    format: "yyyy-MM",
                                    type: "month",
                                    disabled:
                                      _vm.isRoles ||
                                      _vm.detailForm.isDisabled ||
                                      _vm.detailForm.qbrStatus === "CLOSED",
                                    clearable: "",
                                    placeholder: "选择月",
                                  },
                                  model: {
                                    value: _vm.detailForm.month,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "month", $$v)
                                    },
                                    expression: "detailForm.month",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "计划状态",
                                  prop: "planStatus",
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    table: "TT_QSPI_QBR",
                                    field: "PLAN_STATUS",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.planStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "planStatus",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.planStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "QBR日期", prop: "qbrDate" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "picker-options": _vm.pickerOptions,
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    disabled:
                                      _vm.isRoles ||
                                      _vm.detailForm.isDisabled ||
                                      _vm.detailForm.qbrStatus === "CLOSED",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.qbrDateChange },
                                  model: {
                                    value: _vm.detailForm.qbrDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "qbrDate", $$v)
                                    },
                                    expression: "detailForm.qbrDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "材料提交截止日期",
                                  prop: "deadline",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    disabled:
                                      _vm.isRoles ||
                                      _vm.detailForm.isDisabled ||
                                      _vm.detailForm.qbrStatus === "CLOSED",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.deadline,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "deadline", $$v)
                                    },
                                    expression: "detailForm.deadline",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "QBR状态", prop: "qbrStatus" },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    table: "TT_QSPI_QBR",
                                    field: "QBR_STATUS",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.qbrStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "qbrStatus", $$v)
                                    },
                                    expression: "detailForm.qbrStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "QBR Result", prop: "result" },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    table: "TT_QSPI_QBR",
                                    field: "RESULT",
                                    disabled:
                                      _vm.isRoles ||
                                      _vm.detailForm.isDisabled ||
                                      (_vm.detailForm.qbrStatus !==
                                        "PENDING_BY_CQS" &&
                                        _vm.detailForm.qbrStatus !==
                                          "SUBMITTED_BY_SUPPLIER"),
                                  },
                                  model: {
                                    value: _vm.detailForm.result,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "result", $$v)
                                    },
                                    expression: "detailForm.result",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "备注 \n (供应商可见)",
                                  prop: "remarks",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    disabled:
                                      _vm.isRoles ||
                                      _vm.detailForm.isDisabled ||
                                      (_vm.detailForm.qbrStatus !==
                                        "PENDING_BY_CQS" &&
                                        _vm.detailForm.qbrStatus !==
                                          "SUBMITTED_BY_SUPPLIER"),
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "remarks", $$v)
                                    },
                                    expression: "detailForm.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "补充材料备注 \n (供应商可见)",
                                  prop: "supplementaryRemarks",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    disabled: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.supplementaryRemarks,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "supplementaryRemarks",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detailForm.supplementaryRemarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.isRoles
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Talking Point",
                                      prop: "talkingPoint",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        maxlength: "1000",
                                        disabled:
                                          _vm.detailForm.isDisabled ||
                                          _vm.detailForm.qbrStatus === "CLOSED",
                                        "show-word-limit": "",
                                        autosize: { minRows: 4, maxRows: 6 },
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.detailForm.talkingPoint,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "talkingPoint",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.talkingPoint",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "tab_box" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "附件", name: "tab1" } },
                    [
                      (_vm.detailForm.planStatus == "IN_PLAN" ||
                        _vm.detailForm.planStatus == "DELAYED") &&
                      (_vm.detailForm.qbrStatus == "PENDING_BY_SUPPLIER" ||
                        _vm.detailForm.qbrStatus ==
                          "PENDING_ATTACHMENT_BY_SUPPLIER" ||
                        _vm.detailForm.qbrStatus == "PENDING_BY_CQS" ||
                        _vm.detailForm.qbrStatus == "SUBMITTED_BY_SUPPLIER") &&
                      _vm.isRoles
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value:
                                    (_vm.QSPI_QBR_UPLOAD_ATT,
                                    _vm.QSPI_QBR_ADD_DOC,
                                    _vm.QSPI_QBR_ADD_SUPP_DOC),
                                  expression:
                                    "QSPI_QBR_UPLOAD_ATT,QSPI_QBR_ADD_DOC,QSPI_QBR_ADD_SUPP_DOC",
                                },
                              ],
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.openFile },
                            },
                            [_vm._v("选择文件")]
                          )
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.fileData, border: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "documentName", label: "附件名称" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownload(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.documentName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件描述",
                              prop: "docComments",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: scope.row.docComments,
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              maxHeight: "80px",
                                              padding: "10px 0px",
                                              "box-sizing": "border-box",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.docComments)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "userName", label: "上传人" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "createDate", label: "上传时间" },
                          }),
                          (_vm.detailForm.planStatus == "IN_PLAN" ||
                            _vm.detailForm.planStatus == "DELAYED") &&
                          (_vm.detailForm.qbrStatus == "PENDING_BY_SUPPLIER" ||
                            _vm.detailForm.qbrStatus ==
                              "PENDING_ATTACHMENT_BY_SUPPLIER" ||
                            _vm.detailForm.qbrStatus == "PENDING_BY_CQS" ||
                            _vm.detailForm.qbrStatus ==
                              "SUBMITTED_BY_SUPPLIER") &&
                          _vm.isRoles
                            ? _c("el-table-column", {
                                directives: [
                                  {
                                    name: "acl",
                                    rawName: "v-acl",
                                    value:
                                      (_vm.QSPI_QBR_UPLOAD_ATT,
                                      _vm.QSPI_QBR_ADD_DOC,
                                      _vm.QSPI_QBR_ADD_SUPP_DOC),
                                    expression:
                                      "QSPI_QBR_UPLOAD_ATT,QSPI_QBR_ADD_DOC,QSPI_QBR_ADD_SUPP_DOC",
                                  },
                                ],
                                attrs: { label: "操作", width: "80" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          ((_vm.detailForm.qbrStatus ==
                                            "PENDING_BY_SUPPLIER" &&
                                            scope.row.tsReckindId ===
                                              "QSPI_QBR_FILE") ||
                                            ((_vm.detailForm.qbrStatus ==
                                              "PENDING_ATTACHMENT_BY_SUPPLIER" ||
                                              _vm.detailForm.qbrStatus ==
                                                "SUBMITTED_BY_SUPPLIER") &&
                                              scope.row.tsReckindId ===
                                                "QSPI_QBR_FILE_AGAIN") ||
                                            (_vm.detailForm.qbrStatus ==
                                              "PENDING_BY_CQS" &&
                                              (scope.row.tsReckindId ===
                                                "QSPI_QBR_FILE_AGAIN" ||
                                                scope.row.tsReckindId ===
                                                  "QSPI_QBR_FILE"))) &&
                                          _vm.ms_userId === scope.row.createBy
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDel(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.fileData
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  489512677
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "操作日志", name: "tab2" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable2",
                          attrs: {
                            data: _vm.workFlowLogList,
                            "max-height": "500",
                            border: "",
                            stripe: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作时间",
                              prop: "createDate",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作人",
                              prop: "operatorName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作描述",
                              prop: "comments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传附件",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("uploadFile", {
                attrs: { tsRecId: _vm.tsRecId, tsReckindId: _vm.tsReckindId },
                on: { close: _vm.handleClose },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "评分历史版本",
            visible: _vm.showDetailDialog,
            "append-to-body": "",
            width: "70%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [_vm.showDetailDialog ? _c("detailDialog") : _vm._e()],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "补充材料",
            visible: _vm.showFileDialog,
            "append-to-body": "",
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFileDialog = $event
            },
            close: _vm.closeFileDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "supplementForm",
              attrs: {
                model: _vm.supplementForm,
                rules: _vm.supplementFormRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "需要补充材料",
                    prop: "supplementaryMaterials",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.supplementForm.supplementaryMaterials,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.supplementForm,
                            "supplementaryMaterials",
                            $$v
                          )
                        },
                        expression: "supplementForm.supplementaryMaterials",
                      },
                    },
                    _vm._l(
                      _vm.supplementaryMaterialsList,
                      function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "补充材料备注",
                    prop: "supplementaryRemarks",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "100",
                      "show-word-limit": "",
                      autosize: { minRows: 4, maxRows: 6 },
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.supplementForm.supplementaryRemarks,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.supplementForm,
                          "supplementaryRemarks",
                          $$v
                        )
                      },
                      expression: "supplementForm.supplementaryRemarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title_box" }, [
      _c("p", { staticClass: "line" }),
      _c("p", { staticClass: "title" }, [_vm._v("Basic Information")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }